<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<h1 class="chapter">Dedication</h1>
<p class="center"><em>Dedicated to Terry and Kim Moore of Nonviolent <br/>Alternatives (<a href="http://www.nonviolentalternatives.com/" target="_blank">www.nonviolentalternatives.com</a>), for saving my life and helping me heal.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?413da075